import {
  JsonParseError,
  NetworkError,
  ResponseError
} from 'libs/features-api/errors';
import { generateLiffIdTokenApiHeader } from 'libs/features-api/headers';
import { ApiClientConfig, ApiHeaderParams, ApiResponse } from './types';

const API_PATH = '/api/digiclueplus/coupons/unseens/stats';

export class ApiClient {
  private readonly baseUrl: string;

  constructor(config: ApiClientConfig) {
    this.baseUrl = config.baseUrl;
  }

  async call({ tenantCode, idToken }: ApiHeaderParams): Promise<number> {
    const url = this.generateRequestUrl();
    const headers = generateLiffIdTokenApiHeader(tenantCode, idToken);
    const response = await this.invokeApi(url, headers);
    if (!response.ok) {
      throw new ResponseError(response);
    }

    try {
      const json = (await response.json()) as ApiResponse;
      return json.data.couponCount;
    } catch (error) {
      throw new JsonParseError(response);
    }
  }

  private generateRequestUrl(): URL {
    return new URL(API_PATH, this.baseUrl);
  }

  private async invokeApi(
    url: URL,
    headers: Record<string, string>
  ): Promise<Response> {
    try {
      // NOTE: this.fetch = config.fetch window.fetch にすると動かない...?
      return await window.fetch(url.toString(), {
        method: 'GET',
        headers: headers
      });
    } catch (error) {
      throw new NetworkError(url.toString(), error);
    }
  }
}
